import {
  callApi,
  getApiPath,
  checkMobile,
  verifyNotFoundToRedirect,
} from 'api/utils'
import {
  getServerSideProps as getArticleServerSideProps,
  Props as ArticlePageProps,
} from 'components/pages/article'
import {
  getServerSideProps as getCategoryServerSideProps,
  Props as CategoryPageProps,
} from 'components/pages/category/index'
import {
  getServerSideProps as getDrugsPageServerSideProps,
  Props as DrugsPageComponentProps,
} from 'components/pages/drugs'
import { TEMPLATE_AZ_NAME } from 'interfaces/constants'
// import { LOCALE_DRUGS } from 'interfaces/constants'
import { GetServerSideProps, GetServerSidePropsResult } from 'next'
import dynamic from 'next/dynamic'

import { PATHS } from '../api/paths'
import { Category, HealthToolApi } from '../interfaces/types'

export const DrugsPageComponent = dynamic<DrugsPageComponentProps>(
  () => import('components/pages/drugs'),
)
export const ArticlePageComponent = dynamic<ArticlePageProps>(() =>
  import('components/pages/article').then((mod) => mod.ArticlePageComponent),
)
export const CategoryPageComponent = dynamic<CategoryPageProps>(() =>
  import('components/pages/category/index').then(
    (mod) => mod.CategoryPageComponent,
  ),
)

export type BaseProps = {
  isMobileSsr?: boolean
  page: string
  topCategories: Category[]
}
export type Props =
  | ArticlePageProps
  | CategoryPageProps
  | DrugsPageComponentProps

const PostPage = (props: Props) => {
  const { page } = props

  if (page == 'drugs') {
    return <DrugsPageComponent {...(props as DrugsPageComponentProps)} />
  }

  if (page === 'article') {
    return <ArticlePageComponent {...(props as ArticlePageProps)} />
  }
  if (page === 'category') {
    return <CategoryPageComponent {...(props as CategoryPageProps)} />
  }
  return null
}

export const getServerSideProps: GetServerSideProps = async (ctx) => {
  const { query, req, locale } = ctx

  const userAgent = `${req.headers['user-agent']}`
  const isMobileSsr = checkMobile(userAgent)

  const { slug } = query

  let returnRes: GetServerSidePropsResult<
    ArticlePageProps | CategoryPageProps
  > = {
    notFound: true,
  }

  const [articleOrCategoryRes, allHealthTools] = await Promise.all([
    callApi(
      Array.isArray(slug) && slug.length > 0 && slug[0] === 'preview'
        ? getApiPath(PATHS.GET_PREVIEW_ARTICLE, {
            fullSlug: Array.isArray(slug) ? slug.join('/') : slug || '',
            nonce: Array.isArray(query?.preview_nonce)
              ? query?.preview_nonce[0]
              : query?.preview_nonce || '',
          })
        : getApiPath(PATHS.GET_CATEGORY_OR_ARTICLE_DETAIL, {
            fullSlug: Array.isArray(slug) ? slug.join('/') : slug || '',
          }),
      'get',
    ),
    callApi(getApiPath(PATHS.GET_ALL_HEALTH_TOOLS), 'get'),
  ])

  if (articleOrCategoryRes && articleOrCategoryRes.status === 1) {
    if (articleOrCategoryRes.data.post) {
      returnRes = await getArticleServerSideProps(ctx, articleOrCategoryRes)
    } else if (articleOrCategoryRes.data.category) {
      if (articleOrCategoryRes.data.category?.template === TEMPLATE_AZ_NAME) {
        const drugsPageRes = await getDrugsPageServerSideProps(ctx)
        return drugsPageRes
      }

      returnRes = await getCategoryServerSideProps(ctx, articleOrCategoryRes)
    }
  } else if (
    articleOrCategoryRes &&
    articleOrCategoryRes.status === 2 &&
    articleOrCategoryRes.data?.redirect_url
  ) {
    returnRes = {
      redirect: {
        destination: encodeURI(articleOrCategoryRes.data.redirect_url),
        permanent: true,
      },
    }
  }

  if ('props' in returnRes) {
    returnRes.props.isMobileSsr = isMobileSsr
  }

  if ('notFound' in returnRes) {
    returnRes = verifyNotFoundToRedirect(slug, locale || 'vi-VN')
  }

  if ('notFound' in returnRes) {
    const allHealthToolLinks =
      allHealthTools?.data?.map((item: HealthToolApi) =>
        item.link.replace(/\//g, ''),
      ) || []

    if (slug && slug.length > 0) {
      const lastSlug = slug[slug.length - 1]
      if (
        allHealthToolLinks.filter((l: string) => l.indexOf(lastSlug) !== -1)
          .length >= 1
      ) {
        return {
          redirect: {
            destination: `/health-tools/${encodeURI(lastSlug)}/`,
            permanent: true,
          },
        }
      }
    }
  }

  return returnRes
}

export default PostPage
